import { FC } from "react";
import { Link } from "react-router-dom";

export const Page404: FC = () => {
  return (
    <div>
      ページが見つかりませんでした。{" "}
      <Link to="branch/WhmD7p7u5tRo6uJ1VppL/dashboard/analysis">
        サンプルダッシュボードへ
      </Link>
    </div>
  );
};
